import { useQuery } from '@tanstack/react-query';
import { apiSearch, type SearchInput } from '@/lib/queries/search';
import type { SearchResponse } from '@/types/api';

/**
 * Search query. Disabled when `q` is empty, so an empty Search page
 * doesn't fire a request on mount. Keyed on every param so cache hits
 * are tight and the back/forward buttons reuse prior results.
 */
export function useSearch(input: SearchInput) {
  const q = input.q.trim();
  return useQuery<SearchResponse, Error>({
    queryKey: ['search', q, input.mode, input.lang, input.limit ?? 20],
    queryFn: () => apiSearch({ ...input, q }),
    enabled: q.length > 0,
    // The edge cache already TTLs to 5 minutes; mirror that on the client
    // so navigation between pages doesn't refire the request.
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    retry: 1,
  });
}
